import { useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { updateDimensions } from "../Pages/Home/Home.services";

export const useResponsiveMaterial = (
  breakpoint: "xs" | "sm" | "md" | "lg" | "xl",
  direction: "down" | "up" | "only" = "down"
): boolean => {
  const theme = useTheme();

  const query =
    direction === "down"
      ? theme.breakpoints.down(breakpoint)
      : direction === "up"
      ? theme.breakpoints.up(breakpoint)
      : theme.breakpoints.only(breakpoint);

  return useMediaQuery(query);
};

export const useResponsive = () => {
  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
};
